import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

export const getPrintProductQuery = gql`
  query getPrintProduct($id: RecordID!) {
    printProducts(print_product_id: $id, slice: { limit: 1 }) {
      total
      records {
        id
        name
        sizes(slice: { limit: 999 }) {
          total
          records {
            id
            orientations
            print_size {
              id
              name
              width
              height
            }
            mounts {
              total
            }
            total_price {
              value
              currency
            }
          }
        }
        preview_asset_image {
          id
          url
          width
          height
        }
      }
    }
  }
`;

const getPrintProductOptions = {
  options: ({ printProductId }) => ({
    variables: {
      id: printProductId,
    },
  }),
  skip: ({ printProductId }) => !printProductId,
};

const getPrintProduct = graphql(getPrintProductQuery, getPrintProductOptions);

export default getPrintProduct;
